module.exports = __webpack_public_path__ + "static/media/spreadsheet.95ae9b2e.png";